import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteParishNews,
  getParishNews,
  restoreParishNews,
  updateParishNews,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditParishNews() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateParishNews(id, title, description, image);
      if (result) {
        navigate("/parish-news/all");
      }
    } catch (error) {}
  };

  const publishParichNews = async (id) => {
    try {
      await restoreParishNews(id);

      navigate("/parish-news/all");
    } catch (error) {}
  };
  const unPublishParishNews = async (id) => {
    try {
      await deleteParishNews(id);

      navigate("/parish-news/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneParishNews = async (id) => {
    try {
      const result = await getParishNews(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.parishNewsId}
          breadCrumbLink={"Parish News"}
          breadCrumbText={"Edit News"}
          goBackLink={"/parish-news/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishParichNews}
          unPublishItem={unPublishParishNews}
          getOneItem={getOneParishNews}
        />
      </Container>
    </>
  );
}
